/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, Message } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom-v5-compat'
import useUser from '../Shared/UserProvider/useUser'
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery'
import { MOBILE_THRESHOLD } from '../../constants'

const NavigateToBillingFormButton = ({ label }) => {
    const isMobile = useMediaQuery(`(max-width: ${MOBILE_THRESHOLD}px)`)
    const {can} = useUser()
    const canAccessBillingForm = can('STATIC', 'administration')

    if (!canAccessBillingForm) {
        return null
    }

    return (
        <Message
          attached="bottom"
          color="orange"
          size="small"
          fluid
          css={css`
              &.ui.bottom.attached.message {
                  padding-top: 0;
                  padding-left: 1.5rem;
                  padding-right: 1.5rem;
                  box-shadow: -1px -1px 0 0 #f2711c inset,
                  1px -1px 0 0 #f2711c inset,
                  0 -1px 0 0 #f2711c inset;
              }
          `}
        >
            <div css={css`
                text-align: ${isMobile ? 'unset' : 'right'};
            `}
            >
                <Button
                  size="tiny"
                  fluid={isMobile}
                  color="orange"
                  as={NavLink}
                  to="/settings/billing"
                >
                    {label}
                </Button>
            </div>
        </Message>
    )
}

export { NavigateToBillingFormButton }
